export const getUserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
